import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuth } from "./AuthContext";
import { useSingleUser } from "./SingleUserContext";
import { CustomSnackbar } from "../components/snackbar/snackbar.js"; // Import the CustomSnackbar component
import { UndoSendPopover } from "src/components/Custom-Notifications/undoSend/UndoSendPopover";


const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user, getAccessTokenSilently } = useAuth0();
  const { username, setSubUserData } = useAuth();
  const { updateSingleUserData } = useSingleUser();
  const [undoSendOpen, setUndoSendOpen] = useState(false);
const [undoAnchorEl, setUndoAnchorEl] = useState(null);
const undoTimeoutRef = useRef(null);
const queuedSubmitDataRef = useRef(null);

  const [reloadComponents, setReloadComponents] = useState(false);
  const [userSubData, setUserSubData] = useState({
    location_name: "",
    active_location: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    success: "",
  });

  const handleReloadComponents = () => {
    setReloadComponents((prev) => !prev);
  };

  const updateUserData = (newUserData) => {
    setUserSubData(newUserData);
  };

  const updateActiveLocation = (newActiveLocation) => {
    setUserSubData((prevUserData) => ({
      ...prevUserData,
      active_location: newActiveLocation,
    }));
  };

  const fetchLatestUserData = async () => {
    try {
      const accessToken = await getAccessTokenSilently();

      const response = await fetch(
        `${apiUrl}/api/users/profile/${user.sub}/${username}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      const userData = await response.json();

      if (response.ok && userData) {
        setUserSubData(userData);
        setSubUserData(userData);
        setReloadComponents((prev) => !prev);
      } else {
        console.error("Failed to fetch latest user data");
      }
    } catch (error) {
      console.error("Error fetching latest user data:", error);
    }
  };

  // Function to show Snackbar
  const showSnackBar = (message, success) => {
    // Set the Snackbar properties based on success or failure
    setSnackbar({
      open: true,
      message,
      success,
    });
  };



  // Function to handle undo send









  

const triggerUndoSendPopover = (data, anchorEl, onSend) => {
  queuedSubmitDataRef.current = data;
  setUndoAnchorEl(anchorEl);
  setUndoSendOpen(true);

  if (undoTimeoutRef.current) {
    clearTimeout(undoTimeoutRef.current);
  }

  undoTimeoutRef.current = setTimeout(() => {
    // Close the popover first — this will trigger the UI update
    setUndoSendOpen(false);
    setUndoAnchorEl(null);

    // Allow the popover to close smoothly before triggering onSend
    setTimeout(() => {
      if (queuedSubmitDataRef.current) {
        onSend(queuedSubmitDataRef.current);
        queuedSubmitDataRef.current = null;
      }
    }, 0); // Let the DOM update before this runs
  }, 5000);
};

const handleUndoSendClose = () => {
  if (undoTimeoutRef.current) {
    clearTimeout(undoTimeoutRef.current);
  }
  queuedSubmitDataRef.current = null;
  setUndoSendOpen(false);
  setUndoAnchorEl(null);
};

  return (
    <AppContext.Provider
      value={{
        reloadComponents,
        handleReloadComponents,
        userSubData,
        updateUserData,
        updateActiveLocation,
        fetchLatestUserData,
        showSnackBar,
        triggerUndoSendPopover,
        handleUndoSendClose
      }}
    >
      {children}
      {/* Render the CustomSnackbar component */}
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        success={snackbar.success}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
      <UndoSendPopover
  open={undoSendOpen}
  anchorEl={undoAnchorEl}
  handleCloseUndoSend={handleUndoSendClose}
      />
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return {
    ...context,
    fetchLatestUserData: context.fetchLatestUserData,
    showSnackBar: context.showSnackBar, // Include showSnackBar function in the hook return value
  };
};
